import React, {useEffect} from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import AuthRedirect from "../../components/authRedirect";
import CabinetPartnersLevel from "../../components/cabinet/cabinetPartnersLevel";
import CabinetPartnersAllocation from "../../components/cabinet/cabinetPartnersAllocation";
import CabinetPartnersStatistic from "../../components/cabinet/cabinetPartnersStatistic";
import CabinetPartnersLinks from "../../components/cabinet/cabinetPartnersLinks";
import CabinetPartnersList from "../../components/cabinet/cabinetPartnersList";

import {useDispatch} from "react-redux";
import {getPartnersMainData} from "../../store/cabinet/action";
import CabinetPartnersContactCard from "../../components/cabinet/cabinetPartnersContactCard";
import CabinetPartnersConvertPoints from "../../components/cabinet/cabinetPartnersConvertPoints";
import CabinetPartnersCardEditModal from "../../components/cabinet/cabinetPartnersCardEditModal";
import CabinetPartnersPointsHistoryModal from "../../components/cabinet/cabinetPartnersPointsHistoryModal";
import CabinetPartnersConvertPointsHistoryModal
    from "../../components/cabinet/cabinetPartnersConvertPointsHistoryModal";




const CabinetPartnersPage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPartnersMainData());
    }, [dispatch]);

    return (
        <section className={`${Styles.container} ${Styles.cabinetPC}`}>
            <Seo title={t('Партнёры')}/>
            <AuthRedirect isCabinet={true}/>
            <div className={`${Styles.cabinetNote}`}>{t('Партнёрская программа')}</div>
            <div className={`${Styles.posWrap}`}>
                <CabinetPartnersLevel/>
                <CabinetPartnersConvertPoints/>
                <CabinetPartnersAllocation/>
                <CabinetPartnersStatistic/>
                <CabinetPartnersLinks/>
                <CabinetPartnersList/>
                <CabinetPartnersContactCard/>
            </div>
            <CabinetPartnersCardEditModal/>
            <CabinetPartnersPointsHistoryModal/>
            <CabinetPartnersConvertPointsHistoryModal/>
        </section>
    );
};

export default CabinetPartnersPage;